var exports = {
  "YL": "Tooltip.module__tooltip___dDZxTF",
  "xQ": "Tooltip.module__tooltipPointer___dDZxTF",
  "rv": "Tooltip.module__tooltipContent___dDZxTF",
  "iU": "Tooltip.module__tooltipContentLarge___dDZxTF" + " " + "Tooltip.module__tooltipContent___dDZxTF",
  "dn": "Tooltip.module__tooltipTop___dDZxTF",
  "L_": "Tooltip.module__tooltipBottom___dDZxTF",
  "Lf": "Tooltip.module__tooltipLeft___dDZxTF",
  "Uu": "Tooltip.module__tooltipRight___dDZxTF",
  "A4": "Tooltip.module__tooltipPrimary___dDZxTF",
  "yH": "Tooltip.module__tooltipPointerBg___dDZxTF",
  "Rp": "Tooltip.module__tooltipRed___dDZxTF",
  "vX": "Tooltip.module__tooltips___dDZxTF",
  "bZ": "Tooltip.module__hoverFloatingTooltipSurface___dDZxTF",
  "IM": "Tooltip.module__triggerWrapper___dDZxTF",
};

module.exports = exports;
